import styled from 'styled-components';

const MainStyles = styled.main`

`;

export default MainStyles;
